import React, { Component } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    faGraduationCap,
    faBriefcase,
} from "@fortawesome/free-solid-svg-icons";

import "./Resume.css";

class Resume extends Component {
    render() {
        return (
            <section id="resume" style={{ backgroundColor: "#ebebeb" }}>
                <div className="container py-5">
                    <div className="row justify-content-center">
                        <div className="col-md-7 text-center my-3">
                            <h5 className="text-uppercase fw-bold">Resume</h5>
                            <h1
                                className="fw-bold"
                                style={{ fontSize: "2.5rem", color: "#313131" }}
                            >
                                More of My Credentials.
                            </h1>
                            <p className="lead">Proficient in Full Stack Web Development, I create streamlined solutions that make an impact. Eager to tackle challenges and produce top-notch results. Let's innovate together.
                            </p>
                        </div>
                    </div>
                    <div className="row justify-content-center">
                        <h2
                            className="text-center"
                            style={{ fontSize: "2.5rem", color: "#FF0077" }}
                        >
                            My Projects
                        </h2>
                        <div className="col-md-10 col-12">
                            <div className="timeline-wrap">
                                <div className="timeline-block">
                                    <div className="timeline-ico">
                                        <FontAwesomeIcon
                                            style={{ marginTop: "1.25rem" }}
                                            className="fa-2x"
                                            icon={faBriefcase}
                                        />
                                    </div>

                                    <div className="timeline-header">
                                        <h3>Full Stack Developer</h3>
                                    </div>

                                    <div className="timeline-content">
                                        <h4><a target="blank" href="https://luminabazaar.github.io/" className="text-dark text-decoration-none">
Lumina Bazaar: Elevating Online Shopping</a></h4>
                                        <p>Discover Lumina Bazaar - your modern ecommerce haven. Experience curated products, effortless sign-in, user-friendly admin, smart product filtering, secure payments, and an informed order interface. Elevate your shopping with Lumina Bazaar's seamless features.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="row justify-content-center">
                        <h2
                            className="text-center"
                            style={{ color: "#FF0077" }}
                        >
                            Education
                        </h2>
                        <div className="col-md-10 col-12">
                            <div className="timeline-wrap">
                                <div className="timeline-block">
                                    <div className="timeline-ico">
                                        <FontAwesomeIcon
                                            style={{ marginTop: "1.25rem" }}
                                            className="fa-2x"
                                            icon={faGraduationCap}
                                        />
                                    </div>

                                    <div className="timeline-header">
                                        <h3>Bechelor Degree</h3>
                                        <p>October 2022 - Present</p>
                                    </div>

                                    <div className="timeline-content">
                                        <h4>
                                            University of Liberal Arts
                                            Bangladesh
                                        </h4>
                                        <p>
                                            From October 2022, I started my
                                            under-graduation journey on Computer
                                            Science and Engineering at
                                            University of Liberal Arts
                                            Bangladesh.
                                        </p>
                                    </div>
                                </div>

                                <div className="timeline-block">
                                    <div className="timeline-ico">
                                        <FontAwesomeIcon
                                            style={{ marginTop: "1.25rem" }}
                                            className="fa-2x"
                                            icon={faGraduationCap}
                                        />
                                    </div>

                                    <div className="timeline-header">
                                        <h3>Higher Secondary</h3>
                                        <p>July 2019 - December 2022</p>
                                    </div>

                                    <div className="timeline-content">
                                        <h4>Government Science College</h4>
                                        <p>
                                            I completed my Higher Secondary from
                                            Government Science College in 2022.
                                            I started my journey from 2019. Due
                                            to Covid-19 lockdown, it had been
                                            late to complete my examination.
                                        </p>
                                    </div>
                                </div>

                                <div className="timeline-block">
                                    <div className="timeline-ico">
                                        <FontAwesomeIcon
                                            style={{ marginTop: "1.25rem" }}
                                            className="fa-2x"
                                            icon={faGraduationCap}
                                        />
                                    </div>

                                    <div className="timeline-header">
                                        <h3>Learning Softskill</h3>
                                        <p>March 2019 - August 2019</p>
                                    </div>

                                    <div className="timeline-content">
                                        <h4>IBCS Primax Software Bangladesh</h4>
                                        <p>
                                            After my SSC examination in 2019, I
                                            started learning programming from
                                            IBCS Primax Software Bangladesh. I
                                            completed a course on PHP Web
                                            Development. On that course, I was
                                            learnt HTML5, CSS3 with Bootstrap 4,
                                            JavaScript and then PHP with Mysql
                                            database.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        );
    }
}

export default Resume;
